import { joinData } from "./join";
import { LEFT_JOIN_KEY, RIGHT_JOIN_KEY } from "../config";
import { csv } from "d3-fetch";
import SURVEY from "~/data/survey.csv";

export const loadData = () => {
  return Promise.all([
    csv(SURVEY),
    import("~/maps/nyt-no-dc.json")
  ]).then(([inputData, inputMap]) => {
    return joinData({
      dataset1: inputMap,
      dataset2: inputData,
      leftJoinOn: LEFT_JOIN_KEY,
      rightJoinOn: RIGHT_JOIN_KEY,
      appendKey: "status"
    });
  });
};
